L.Control.ShareControl = L.Control.extend({

    initialize: function (options) {
        L.Util.setOptions(this, options);
    },

    _hasRoute: function() {
        return control._selectedRoute && control._selectedRoute.geometry;
    },

    _exportGpx: function() {

        if (!this._hasRoute()) {
           alert(L.localisation.get('error.plotRouteFirst'));
           return;
        }

	window.location.href = control.getRouter().buildRouteUrl(control.getWaypoints(), control.getPlan().options, control._selectedRoute, true) + "&output=gpx";
    },

    _exportKml: function() {

        if (!this._hasRoute()) {
           alert(L.localisation.get('error.plotRouteFirst'));
           return;
        }

        window.location.href = control.getRouter().buildRouteUrl(control.getWaypoints(), control.getPlan().options, control._selectedRoute, true) + "&output=kml";
    },

    show: function() {

        var container = L.DomUtil.get('share-container');

        // Show saved routes if desktop currently
        if (!is_app || app_version >= 1.3) {
           this._showSavedRoutes();
        }

        /* Export GPX & KML */
        var exportContainer = L.DomUtil.create('div', 'gpx-container', container);
        var exportParagraph = L.DomUtil.create('p', '', exportContainer);
        exportParagraph.innerHTML = L.localisation.get('share.exportMessage');
        var exportGpxButton = L.DomUtil.create('a', 'btn btn-small btn-gpx', exportContainer);
        exportGpxButton.innerHTML = L.localisation.get('share.exportGpx');
        L.DomEvent.on(exportGpxButton, 'click', this._exportGpx, this);
        var exportKmlButton = L.DomUtil.create('a', 'btn btn-small btn-kml', exportContainer);
        exportKmlButton.innerHTML = L.localisation.get('share.exportKml');
        L.DomEvent.on(exportKmlButton, 'click', this._exportKml, this);

        /* Link sharing */
        var linkContainer = L.DomUtil.create('div', 'shorten-container', container);
        var linkParagraph = L.DomUtil.create('p', '', linkContainer);
        linkParagraph.innerHTML = L.localisation.get('share.shareableLinkMessage');
        this.linkInput = L.DomUtil.create('input', 'shorten-input', linkContainer);
        this.linkInput.value = '';
        this.linkInput.disabled = true;
        var linkButton = L.DomUtil.create('a', 'btn btn-small btn-block', linkContainer);
        linkButton.innerHTML = L.localisation.get('share.shareableLink');
        L.DomEvent.on(linkButton, 'click', this._shortenUrl, this);
        
        return this;
    },

    _showSavedRoutes: function() {

        var container = L.DomUtil.get('share-container');

        // Logged-in state
        var savedRoutesContainer = L.DomUtil.get('favs-logged-in-container');
        var savedRoutesIntro = L.DomUtil.create('div', 'saved-routes-intro', savedRoutesContainer);
        var savedRoutesTitle = L.DomUtil.create('span', '', savedRoutesIntro);
        savedRoutesTitle.innerHTML = L.localisation.get('share.yourSavedRoutes');
        var jsSignOutButton = L.DomUtil.create('a', 'saved-routes-signout', savedRoutesIntro);
        jsSignOutButton.setAttribute('href','javascript:void(0)');
        jsSignOutButton.innerHTML = L.localisation.get('share.logout');
        this._jsSignOutButton = jsSignOutButton;
        L.DomEvent.on(jsSignOutButton, 'click', this._signOut, this);

        // Google auth
        var loginContainer = L.DomUtil.get('favs-login-container');
        loginContainer.setAttribute('style','display:block');
        var loginIntro = L.DomUtil.create('p', 'login-intro', loginContainer);
        loginIntro.innerHTML = L.localisation.get('share.loginMessage');
        var jsSignInButton = L.DomUtil.create('a', '', loginContainer);
        jsSignInButton.setAttribute('style','cursor:pointer');
        jsSignInButton.innerHTML = '<img src="/static/google-btn.png" style="margin:0 12px 3px 0" />';
        this._jsSignInButton = jsSignInButton;

        // Apple auth (used for both app and web)
        // Don't both showing on Android devices
        if (!L.Browser.android && typeof AppleID !== 'undefined') {

             var appleSignInButton = L.DomUtil.create('a', '', loginContainer);
             appleSignInButton.setAttribute('style','cursor:pointer');
             appleSignInButton.innerHTML = '<img src="/static/apple-btn.png" style="margin: 3px 0" />';
             L.DomEvent.on(appleSignInButton, 'click', function() {
                 this._runAuth('apple', 'sign-in', function() { return AppleID.auth.signIn(); });
             }, this);

             AppleID.auth.init({
                 clientId : 'com.trailrouter.apple',
                 scope : 'email',
                 redirectURI : 'https://'+window.location.hostname+'/redirect',
                 state : '345jb34k5lyu345bbgdfg',
                 usePopup : true
            });
            L.DomEvent.on(document, 'AppleIDSignInOnSuccess', function(data) {
                 this.signInCallback(data.detail.authorization.code, "apple");
            }, this);
            document.addEventListener('AppleIDSignInOnFailure', L.bind(function(event) {
                 this._authFailure('apple', 'sign-in', event.detail);
            }, this));
        }

        // Attach Android wrapper to sign-in button
        if (typeof app !== 'undefined') {
          this._hookSignInOutButtons();

        // Attach button to web sign in
        } else if (!is_app) {
           this._initializeGoogleAuth();
        }

        // Show route list
        this._routeTable = L.DomUtil.create('table','saved-routes',savedRoutesContainer);
        // Save button
        var saveRouteButton = L.DomUtil.create('a', 'btn btn-small btn-block', savedRoutesContainer);
        saveRouteButton.innerHTML = L.localisation.get('share.saveCurrentRoute');
        saveRouteButton.style.margin = '10px 0 0 0';
        L.DomEvent.on(saveRouteButton, 'click', this._saveRoute, this);

        // Set token if already logged in
        var token;
        try { token = localStorage.getItem('accessToken'); } catch (error) {}
        if (token != null) {
           this._accessToken = token;
           this._signInComplete();
        }
    },

    _initializeGoogleAuth: function() {
        // Provider initialization is independent of an existing Trail Router session.
        this._googleAuthReady = false;
        L.DomEvent.on(this._jsSignInButton, 'click', function() {
            if (!this._googleAuthReady) {
                this._authFailure('google', 'sign-in', new Error('Google sign-in is unavailable'));
            }
        }, this);
        var failed = L.bind(function(error) {
            this._googleAuthReady = false;
            this._authFailure('google', 'initialize', error);
        }, this);
        try {
            if (typeof gapi === 'undefined') return;
            gapi.load('auth2', L.bind(function() {
                try {
                    var auth2 = this._auth2 = gapi.auth2.init({
                        client_id: '160848283571-q23k0se0hsbi4ijrib87qbrd953k877a.apps.googleusercontent.com',
                        cookiepolicy: 'single_host_origin'
                    });
                    auth2.then(L.bind(function() {
                        try {
                            auth2.attachClickHandler(this._jsSignInButton, {}, L.bind(function(googleUser) {
                                this.signInCallback(googleUser.getAuthResponse().id_token, 'google');
                            }, this), L.bind(function(error) {
                                this._authFailure('google', 'sign-in', error);
                            }, this));
                            this._googleAuthReady = true;
                        } catch (error) { failed(error); }
                    }, this), failed);
                } catch (error) { failed(error); }
            }, this));
        } catch (error) { failed(error); }
    },

    _runAuth: function(provider, operation, run, success) {
        this._lastAuthFailure = null;
        if (window.TrailRouterDiagnostics) TrailRouterDiagnostics.breadcrumb('auth.' + operation, { provider: provider });
        var failure = L.bind(function(error) { this._authFailure(provider, operation, error); }, this);
        try {
            var result = run();
            if (result && typeof result.then === 'function') {
                result.then(function(value) {
                    try { if (success) success(value); } catch (error) { failure(error); }
                }, failure);
            }
        } catch (error) { failure(error); }
    },

    _authFailure: function(provider, operation, error) {
        var code = typeof error === 'string' ? error : error && (error.error || error.code);
        // Closing an auth popup is a normal action.
        if (code === 'user_cancelled_authorize' || code === 'popup_closed_by_user' || code === 'access_denied') return;
        var key = provider + ':' + operation + ':' + String(code || 'unknown');
        if (this._lastAuthFailure && this._lastAuthFailure.key === key && Date.now() - this._lastAuthFailure.time < 1000) return;
        this._lastAuthFailure = { key: key, time: Date.now() };
        if (window.TrailRouterDiagnostics) {
            // Do not attach the provider response: it may contain credentials.
            TrailRouterDiagnostics.report(new Error('Authentication ' + operation + ' failed'),
                { provider: provider, operation: operation });
        }
        // No sign-in was attempted. Keep routing and restored sessions usable.
        if (operation === 'initialize') return;
        var message = L.DomUtil.get('routing-error');
        message.textContent = operation === 'sign-out' ? 'Unable to sign out. Please try again.' : 'Unable to sign in. Please try again.';
        message.style.visibility = 'visible';
    },

    // Used only by iOS because `app` isn't injected early enough into page execution
    _hookSignInOutButtons: function() {
        if (this._nativeSignInHooked) return;
        this._nativeSignInHooked = true;
        L.DomEvent.on(this._jsSignInButton, 'click', function() { app.jsSignIn(); }, this);
    },

    _signOut: function() {
        // The local session must end even if a provider is unavailable or rejects sign-out.
        this.signOutCallback();
        if (typeof app !== 'undefined' && typeof app.jsSignOut === 'function') {
            this._runAuth('native', 'sign-out', function() { return app.jsSignOut(); });
        } else if (this._auth2 && typeof this._auth2.signOut === 'function') {
            this._runAuth('google', 'sign-out', L.bind(function() { return this._auth2.signOut(); }, this));
        }
    },

    _safeRouteUrl: function(value) {
        if (typeof value !== 'string' || !value.trim()) return null;
        try {
            var url = new URL(value, window.location.href);
            if (url.protocol === 'https:' || url.protocol === 'http:') return url.href;
        } catch (error) {}
        return null;
    },

    _refreshSavedRouteList: function() {

        this._restCall('GET', '/ors/savedroutes', null, L.bind(function(resp) {
            this._savedRoutes = JSON.parse(resp);
            this._displaySavedRouteList();
        },this));
    },

    _displaySavedRouteList: function() {
        var tr, td, a;

        while (this._routeTable.firstChild) {
           this._routeTable.removeChild(this._routeTable.firstChild);
        }

        // Handle no saved routes
        if (!this._savedRoutes || this._savedRoutes.length == 0) {
           tr = L.DomUtil.create('tr', '', this._routeTable);
           td = L.DomUtil.create('td', '', tr);
           td.innerHTML = L.localisation.get('share.noSavedRoutes');
        }

        // Create table of saved routes
        for (var i = 0; i < (this._savedRoutes || []).length; i++) {
           tr = L.DomUtil.create('tr', '', this._routeTable);
           tr.setAttribute('data-route-id', this._savedRoutes[i].id);

           // route name and link
           td = L.DomUtil.create('td', 'c1', tr);
           a = L.DomUtil.create('a','',td);
           a.textContent = this._savedRoutes[i].name;
           var routeUrl = this._safeRouteUrl(this._savedRoutes[i].url);
           if (routeUrl) a.href = routeUrl;
           L.DomEvent.addListener(a, 'mousedown', L.DomEvent.preventDefault);

           // rename link
           td = L.DomUtil.create('td', 'c2', tr);
           a = L.DomUtil.create('a','',td);
           a.setAttribute('data-route-id', this._savedRoutes[i].id);
           a.setAttribute('style','cursor:pointer');
           a.innerHTML = '<i class="fa fa-pencil-square-o"></i>';
           L.DomEvent.addListener(a, 'click', L.bind(this._renameRoute,this));

           // delete link
           td = L.DomUtil.create('td', 'c3', tr);
           a = L.DomUtil.create('a','',td);
           a.setAttribute('data-route-id', this._savedRoutes[i].id);
           a.setAttribute('style','cursor:pointer');
           a.innerHTML = '<i class="fa fa-trash-o"></i>';
           L.DomEvent.addListener(a, 'click', L.bind(this._deleteRoute,this));
        }
    },

    signInCallback: function(token, src) {

        var errdiv = L.DomUtil.get("routing-error");
        var http = new XMLHttpRequest();
        http.open('GET', '/ors/login', true);

        if (src == "google") {
           http.setRequestHeader('X-Google-Token', token);
        } else if (src == "apple") {
           http.setRequestHeader('X-Apple-Token', token);
        }

        http.onreadystatechange = L.bind(function() {
            if (http.readyState == 4 && http.status >= 200 && http.status < 300) {
                errdiv.style.visibility = 'hidden';

                this._accessToken = http.responseText;
                try { localStorage.setItem('accessToken', this._accessToken); } catch (error) {}
                this._signInComplete();

            } else if (http.readyState == 4 && http.status >= 400) {
                control.fire('routingerror', {error: {message:'Authentication failed, please sign out and sign back in'}});
            }
        },this);

        http.onerror = L.bind(function(e) {
           control.fire('routingerror', {error: {message:'Authentication failed, please sign out and sign back in'}});
        }, this);

        http.ontimeout = http.onerror;
        http.send();
    },

    _signInComplete: function() {
        L.DomUtil.get('favs-login-container').style.display = 'none';
        L.DomUtil.get('favs-logged-in-container').style.display = 'block';
        this._refreshSavedRouteList();
    },

    signOutCallback: function() {
        L.DomUtil.get('favs-login-container').style.display = 'block';
        L.DomUtil.get('favs-logged-in-container').style.display = 'none';
        this._accessToken = null;
        try { localStorage.removeItem('accessToken'); } catch (error) {}
        this._savedRoutes = [];
        if (this._routeTable) this._displaySavedRouteList();
    },

    _routeAction: function(event) {
        var anchor = event.currentTarget;
        var id = anchor && anchor.getAttribute('data-route-id');
        var row = anchor && anchor.parentNode && anchor.parentNode.parentNode;
        if (!row || row.parentNode !== this._routeTable || id === null) return null;
        var routes = this._savedRoutes || [];
        for (var i = 0; i < routes.length; i++) {
            if (String(routes[i].id) === id) return { route: routes[i], row: row };
        }
        // The list changed while the action was pending.
        this._displaySavedRouteList();
        return null;
    },

    _renameRoute: function(el) {

        var action = this._routeAction(el);
        if (!action) return;
        var route = action.route;
        var tr = action.row;

        while (tr.firstChild) {
           tr.removeChild(tr.firstChild);
        }

        // route name
        var td = L.DomUtil.create('td', 'c1', tr);
        var input = L.DomUtil.create('input','',td);
        input.setAttribute('maxlength','256');
        input.value = route.name;

        // save button
        td = L.DomUtil.create('td', 'c2', tr);
        var a = L.DomUtil.create('a','',td);
        a.setAttribute('style','cursor:pointer');
        a.innerHTML = '<i class="fa fa-check"></i>';
        L.DomEvent.addListener(a, 'click', L.bind(function() {
           var body = { name: input.value };
           this._restCall('PATCH', '/ors/savedroutes?id='+encodeURIComponent(route.id), body, L.bind(this._refreshSavedRouteList,this));
        },this));

        // cancel link
        td = L.DomUtil.create('td', 'c3', tr);
        a = L.DomUtil.create('a','',td);
        a.setAttribute('style','cursor:pointer');
        a.innerHTML = '<i class="fa fa-ban"></i>';
        L.DomEvent.addListener(a, 'click', L.bind(this._refreshSavedRouteList,this));
    },

    _deleteRoute: function(el) {
        var action = this._routeAction(el);
        if (!action) return;
        var route = action.route;
        if (confirm(L.localisation.get('share.deleteConfirm'))) {
           this._restCall('DELETE', '/ors/savedroutes?id='+encodeURIComponent(route.id), null, L.bind(this._refreshSavedRouteList,this));
        }
    },

    _saveRoute: function() {

        if (!this._hasRoute()) {
           alert(L.localisation.get('error.plotRouteFirst'));
           return;
        }

        var body = {
           name: control._selectedRoute.resolveName(),
           url: window.location.href,
           geometry: control._selectedRoute.geometry,
           distance: control._selectedRoute.summary.totalDistance
        }

        this._restCall('POST', '/ors/savedroutes', body, L.bind(this._refreshSavedRouteList,this));
    },

    _restCall: function(verb, path, data, cb) {

        var errdiv = L.DomUtil.get("routing-error");
        var http = new XMLHttpRequest();
        var url = path;
        http.open(verb, url, true);

        // set TR token
        var token = this._accessToken;
        http.setRequestHeader('X-Access-Token', token);

        if (data)
           http.setRequestHeader('Content-type', 'application/json');

        http.onreadystatechange = L.bind(function() {
            if (http.readyState == 4 && http.status >= 200 && http.status < 300) {
                errdiv.style.visibility = 'hidden';
                if (cb) cb(http.responseText);
            } else if (http.readyState == 4 && http.status >= 400) {
                control.fire('routingerror', {error: {message:'Authentication failed, please sign out and sign back in'}});
            }
        },this);

        http.onerror = L.bind(function(e) {
            errdiv.innerHTML = e;
            errdiv.style.visibility = 'visible';
        }, this);

        http.ontimeout = http.onerror;
        if (data) {
           http.send(JSON.stringify(data));
        } else {
           http.send();
        }
    },

    _shortenSuccess: function(response) {
            this.linkInput.value = response;
            this.linkInput.style.display = 'block';
            this.linkInput.disabled = false;
            this.linkInput.select();
            this.linkInput.setSelectionRange(0, 99999);
            document.execCommand("copy");
            this.linkInput.disabled = true;
    },

    _shortenUrl: function() {

        if (!this._hasRoute()) {
           alert(L.localisation.get('error.plotRouteFirst'));
           return;
        }

        var routeUrl = window.location.href;
        var requestId = this._shortenRequestId = (this._shortenRequestId || 0) + 1;
        // Cache the URL and its response together, only after a successful request.
        if (this._shortenedUrl && this._shortenedUrl.url === routeUrl) {
           this._shortenSuccess(this._shortenedUrl.response);
           return;
        }

        this.linkInput.value = '';

        var errdiv = L.DomUtil.get("routing-error");
        var http = new XMLHttpRequest();
        var url = '/shorten';
        var params = 'url='+encodeURIComponent(routeUrl);
        http.open('POST', url, true);
        http.timeout = 15000;
        http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

        var finished = false;
        var complete = L.bind(function(success) {
            if (finished) return;
            finished = true;
            if (requestId !== this._shortenRequestId || window.location.href !== routeUrl || !this._hasRoute()) return;
            if (success) {
                errdiv.style.visibility = 'hidden';
                this._shortenedUrl = { url: routeUrl, response: http.responseText };
                this._shortenSuccess(http.responseText);
            } else {
                control.fire('routingerror', {error: {message:'URL shortening failed'}});
            }
        }, this);

        http.onreadystatechange = function() {
            if (http.readyState === 4) complete(http.status === 201);
        };

        http.onerror = function() { complete(false); };
        http.ontimeout = http.onerror;
        http.send(params);
    }
});
